module.exports = __webpack_public_path__ + "static/media/959399E2-DEB1-405D-80E2-C7F830E6FD8F.25f182c9.jpeg";